/**
 * @file：用户调研问卷 request
 */

import { request } from './request';
import { ApiConfigs, Response } from '../schemas/service';

const api: ApiConfigs = {
  createQuestionnaire: {
    url: '/health/api/v1/order/createQuestionnaire',
    method: 'POST'
  },
  queryQuestionnaireState: {
    url: '/health/api/v1/order/queryQuestionnaireState',
    method: 'GET'
  }
};

const userSatisfactionSurvey = {
  async createQuestionnaire(params) {
    try {
      const response: Response = await request(
        api.createQuestionnaire,
        undefined,
        params
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async queryQuestionnaireState(orderId) {
    try {
      const response: Response = await request(api.queryQuestionnaireState, {
        orderId
      });
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default userSatisfactionSurvey;
